import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/app/app';
import { Providers } from '@/app/providers';
import { initSentry } from '@/config/sentry';
import { logger } from '@/lib/logger';

import '@/styles/globals.css';

initSentry(__SENTRY_DSN__);

logger.info('OnePortal starting', {
  version: __APP_VERSION__,
  env: __ENV__,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>
);
